import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.98 20.156C11.125 23.55 14.405 26 18.273 26 23.093 26 27 22.194 27 17.5S23.093 9 18.273 9c-3.23 0-6.051 1.71-7.56 4.25m-.733-.83 1.202 1.096m2.182.796H9v-4.25l4.364 4.25Z",
      stroke: "#fff",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }